import { render, staticRenderFns } from "./GdprCookieSetup.vue?vue&type=template&id=4fc3dbd6&scoped=true&"
import script from "./GdprCookieSetup.vue?vue&type=script&lang=js&"
export * from "./GdprCookieSetup.vue?vue&type=script&lang=js&"
import style0 from "./GdprCookieSetup.vue?vue&type=style&index=0&id=4fc3dbd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc3dbd6",
  null
  
)

export default component.exports